import presentationModules from './presentation/index'
import pricingModules from './pricing/index'
import configurationModules from './configuration/index'

export default {
  ...presentationModules,
  ...pricingModules,
  ...configurationModules,
}
